'use client';

import { Logo } from '@petsmart-ui/sparky';

import { NAVIGATION_URLS } from '@libs/core';

import { trackNavigationHeaderClick } from '../../shared';

type HeaderLogoProps = {
    className?: string;
    title?: string;
};

export function HeaderLogo({ className, title }: Readonly<HeaderLogoProps>) {
    function handleClick() {
        trackNavigationHeaderClick({
            selection: 'logo',
            linkUrl: NAVIGATION_URLS.legacy.base,
        });
    }

    return <Logo href={NAVIGATION_URLS.legacy.base} title={title} className={className} onClick={handleClick} />;
}
